"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringGroupsLoader = void 0;
const react_hooks_1 = require("@apollo/react-hooks");
const consts_1 = require("@opsbase/lib-data-query/consts");
const NotSpecified_1 = require("@opsbase/lib-general/NotSpecified");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
const useDataTree_1 = __importDefault(require("../../useDataTree"));
const useDataTreeActions_1 = __importDefault(require("../../useDataTreeActions"));
function StringGroupsLoader(props) {
    const { groupBy } = props;
    const { viewId } = (0, useDataTree_1.default)();
    const { setGroupCollectionForGroupBy } = (0, useDataTreeActions_1.default)();
    const view = (0, useView_1.default)(viewId);
    const { filters, reportPage, type } = view;
    const self = (0, useSelf_1.default)();
    // If we're filtering by items in the group, we simply return with those
    const filterIds = filters
        .filter(fb => fb.queryFieldKey === groupBy.queryFieldKey)
        .map(fb => fb.id);
    const skip = !!filterIds.length;
    const variables = {
        type,
        fieldName: groupBy.queryFieldKey,
        offset: reportPage * consts_1.GroupPageSize,
        limit: consts_1.GroupPageSize,
    };
    const gqlStr = (0, graphql_tag_1.default) `
		query VALUESEARCH($type: String!, $offset: Int, $limit: Int, $fieldName: String) {
			valueSearch(type: $type, offset: $offset, limit: $limit, fieldName: $fieldName) {
				offset
				limit
				totalCount
				items
			}
		}
	`;
    const { loading, data } = (0, react_hooks_1.useQuery)(gqlStr, {
        variables,
        fetchPolicy: 'network-only',
        skip,
    });
    (0, react_1.useEffect)(() => {
        var _a;
        let groups = undefined;
        let totalCount = undefined;
        // Add Items from Filters List
        if (skip) {
            groups = filterIds.map(value => (Object.assign(Object.assign({}, groupBy), { id: value, title: value })));
            totalCount = filterIds.length;
        }
        // Add Loaded Items
        else if (data === null || data === void 0 ? void 0 : data.valueSearch) {
            // FALSE POSITIVE
            // eslint-disable-next-line sonarjs/no-identical-functions
            groups = (_a = data === null || data === void 0 ? void 0 : data.valueSearch) === null || _a === void 0 ? void 0 : _a.items.map(value => (Object.assign(Object.assign({}, groupBy), { id: value, title: value })));
            totalCount = data.totalCount;
            // Add not specified
            if (reportPage === 0) {
                groups.push(Object.assign(Object.assign({}, groupBy), { id: NotSpecified_1.NOTSPECIFIED, title: 'Not specified' }));
            }
        }
        setGroupCollectionForGroupBy(groupBy, {
            loading,
            lastLoaded: new Date(),
            totalCount,
            groups,
        });
    }, [loading, data, groupBy, reportPage, self, setGroupCollectionForGroupBy, skip, filterIds]);
    return null;
}
exports.StringGroupsLoader = StringGroupsLoader;
exports.default = StringGroupsLoader;
